// @ts-ignore
import { Tab } from 'bootstrap';

window.addEventListener('DOMContentLoaded', (event) => {
    const target = window.location.hash;

    if (!target) {
       return;
    }

    const element = document.querySelector(target);

    if (!element) {
        return;
    }

    const tab = new Tab(element);

    if (!tab) {
        return;
    }

    tab.show();

}, {once : true});
